import { Center, Flex, Image, Link, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Container from '../common/container';
import AppImage from '../assets/push-training-app.png';
import DownloadOnAppStoreImage from '../assets/download-on-the-app-store.svg';
import GetItOnGooglePlayImage from '../assets/GetItOnGooglePlay.svg';
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  detectPlatform,
  getBestDownloadUrl,
} from '../utils/appStoreLinks';

const DownloadPage = () => {
  const [searchParams] = useSearchParams();
  const campaignTag = searchParams.get('ct') ?? undefined;
  const [shouldShowOptions, setShouldShowOptions] = useState(false);

  useEffect(() => {
    const platform = detectPlatform();
    const bestUrl = getBestDownloadUrl(campaignTag);

    if (platform !== 'unknown' && bestUrl) {
      window.location.href = bestUrl;
      const fallbackTimer = setTimeout(() => setShouldShowOptions(true), 1500);
      return () => clearTimeout(fallbackTimer);
    }
    setShouldShowOptions(true);
    return undefined;
  }, [campaignTag]);

  if (!shouldShowOptions) {
    return (
      <Container>
        <Center marginTop={'20vh'}>
          <Text>Redirecting...</Text>
        </Center>
      </Container>
    );
  }

  const appStoreUrl = campaignTag
    ? `${APP_STORE_URL}?pt=80648800&ct=${campaignTag}&mt=8`
    : APP_STORE_URL;

  const playStoreUrl = campaignTag
    ? `${PLAY_STORE_URL}&utm_source=web&utm_campaign=${campaignTag}`
    : PLAY_STORE_URL;

  return (
    <Container>
      <Center flexDirection={'column'} marginTop={'10vh'}>
        <Image
          src={AppImage}
          borderRadius={'2xl'}
          width={'100px'}
          backgroundColor={'dripSecondaryFill'}
        />
        <Text marginTop={'4'} fontWeight={'bold'} fontSize={'xl'}>
          Treadmill Workout Push Training
        </Text>
        <Text color={'lightGray'} textAlign={'center'}>
          Get the app to continue
        </Text>

        <Flex
          direction={'column'}
          gap={'8'}
          marginTop={'8'}
          alignItems={'center'}
        >
          <Link href={appStoreUrl} _hover={{ opacity: 0.8 }}>
            <Image
              src={DownloadOnAppStoreImage}
              alt="Download on the App Store"
              height={'50px'}
            />
          </Link>

          <Link href={playStoreUrl} _hover={{ opacity: 0.8 }}>
            <Image
              src={GetItOnGooglePlayImage}
              alt="Get it on Google Play"
              height={'50px'}
            />
          </Link>
        </Flex>
      </Center>
    </Container>
  );
};

export default DownloadPage;
